<!--
 * @FileDescription: 图片轮播组件
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-07-26 13:04:55
 -->
<template>
  <DvBorderBox2 class="pic-template" :order="order" :keyId="keyId">
    <!-- <div class="pic-container" v-if="keyId=='2'">
      <el-carousel height="100%" class="pic-carousel" ref="unionPicCarousel" indicator-position="none" :autoplay="false">
        <el-carousel-item v-for="item in picInfo1" :key="item.name">
          <img :src="item.imgSrc" class="image-bg">
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <div class="pic-container" v-if="keyId=='2'">
      <el-carousel height="100%" class="pic-carousel" ref="unionPicCarousel" indicator-position="none" :autoplay="false">
        <el-carousel-item v-for="item in picInfo2" :key="item.properties.name">
          <img :src="item.properties.imgUrl" class="image-bg">
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <div class="pic-container" v-else-if="keyId=='3'">
      <el-carousel height="100%" class="pic-carousel" ref="searchPicCarousel" indicator-position="none" :autoplay="false">
        <el-carousel-item v-for="item in picInfo2" :key="item.name">
          <img :src="item.imgSrc" class="image-bg">
        </el-carousel-item>
      </el-carousel>
    </div> -->
  </DvBorderBox2>
</template>

<script>
export default {
  name: 'PicCarouselTemplate',
}
</script>

<script setup>
import { defineProps, ref, watch,onMounted } from 'vue';
import { BorderBox2 as DvBorderBox2 } from '@kjgl77/datav-vue3';
// import { schoolData } from './schoolData';
// import activeJson from "@/components/activeChartData.json"
import axios from 'axios';

let props = defineProps({
  order: String,
  schoolIndex: Number,
  keyId: String,
  searchSciIndex: Array
});
console.log('pic porps', props.schoolIndex)
let activeJson=ref({})
let unionPicCarousel = ref();
let picInfo2 = ref([])
// let searchPicCarousel = ref();

// const picInfo1 = schoolData;

onMounted(() => {
//   console.log(`the component is now mounted.`)
  axios.get('/activeChartData.json')
      .then(response => {
        activeJson.value= response.data;
        picInfo2.value=activeJson.value.unionSchoolPt.features
      })
      .catch(error => {
        console.log(error);
      });
})
// const picInfo2 = activeJson.unionSchoolPt.features;

watch(props, (newProps) => {
  unionPicCarousel.value.setActiveItem(newProps.schoolIndex - 1);
  // searchPicCarousel.value.setActiveItem(newProps.searchSciIndex - 1);
})
// onMounted(() => {
//   picCarousel.value.setActiveItem(props.schoolIndex - 1);
// })

</script>


<style lang="scss" scoped>
$orders: 1, 2, 3, 4, 5, 6, 7, 8;

div.pic-template {
  &[keyId="2"] {
    position: relative;
    margin-top: 1vh;
    margin-bottom: 1vh;
    width: 30vw;
    height: 38vh;
    z-index: 11;
  }
  &[keyId="3"] {
    position: relative;
    margin-top: 2vh;
    margin-bottom: 1vh;
    width: 25vw;
    height: 23vh;
  }

  @each $order in $orders {
    &[order='#{$order}'] {
      order: $order;
    }
  } 

  div.border-box-content {
    width: 30vw;
    height: 38vh;
    border-radius: 10px;

    div.pic-container {
      position: absolute;
      top: 0.7%;
      left: 0.7%;
      width: 98.6%;
      height: 98.6%;
      z-index: 10;
      border-radius: 8px;
      overflow: hidden;

      .pic-carousel {
        width: 100%;
        height: 100%;

        .el-carousel__container {
          width: 100%;
          height: 100%;

          .image-bg {
            height: 100%;
            width: 100%;
            // background-image: url('http://223.2.9.189:8080/image/南京师范大学吴江实验幼儿园（图片1）.jpg');
            background-repeat: no-repeat;
            background-size: cover;
          }
        }
      }
    }

  }
}
</style>
